import { useMutation } from "@apollo/client"
import { getCommentsConsultant } from "../../graphql/submission/queries"
import { useApolloClient } from "@apollo/client"
import { useAuth } from "../../contexts/auth"
import { submission as graphQL, submission } from "../../graphql"
import { useQuery } from "@apollo/client"
import { useCallback } from "react"
import { loadingAlert } from "../../helpers"
import { success } from "../../helpers"
import { ApolloError } from "@apollo/client"

export const useConsultantComments = ({
    consultant
  }) => {
    const client = useApolloClient()
    const id = consultant?.id
  
    const auth = useAuth() || {}
    const { user } = auth
  
    const userAuthenticate = user?.claims?.role
  
    const entities = [
      {
        entity: "consultant",
        id
      }
    ]
  
    const [deleteComments] = useMutation(
      graphQL.mutations.deleteComments,
      { client }
    )
  
    const {
      loading,
      data,
      refetch
    } = useQuery(
      graphQL.queries.getCommentsConsultant,
      {
        client,
        variables: {
          entities
        },
        skip: !id
      }
    )
  
    const [upsert] = useMutation(
      graphQL.mutations.upsertComments,
      { client }
    )
  
    const save = useCallback(
      async (comment, parentCommentId = null) => {
        const saving = loadingAlert()
  
        try {
          const data = [{
            comment,
            consultant: id,
            type: "CONSULTANT",
            fieldName: "CONSULTANT",
            userRol: userAuthenticate,
            ...(parentCommentId && {
              parentCommentId
            })
          }]
  
          await upsert({
            variables: {
              data
            }
          })
  
          await refetch()
  
          success()
        } catch (e) {
          ApolloError(e)
        } finally {
          saving()
        }
      },
      [
        id,
        upsert,
        refetch,
        userAuthenticate
      ]
    )
  
    const reviewedComment = useCallback(
      async ({ id, reviewed }) => {
        const saving = loadingAlert()
  
        try {
          const data = [{
            id,
            reviewed
          }]
  
          await upsert({
            variables: {
              data
            }
          })
  
          await refetch()
  
          success(
            reviewed
              ? "Comentario marcado como solucionado"
              : "Comentario marcado como pendiente"
          )
        } catch (error) {
          apolloError(error)
        } finally {
          saving()
        }
      },
      [upsert, refetch]
    )
  
    const deleteComment = useCallback(
      async commentId => {
        const saving = loadingAlert()
  
        try {
          await deleteComments({
            variables: {
              data: [commentId]
            }
          })
  
          await refetch()
  
          success("Eliminado correctamente!")
        } catch (e) {
          apolloError(e)
        } finally {
          saving()
        }
      },
      [deleteComments, refetch]
    )
  
    const comments =
      data?.CommentsConsultant?.filter(
        comment => comment.type === "CONSULTANT"
      ) || []
  
    return {
      comments,
      loading,
      save,
      deleteComment,
      reviewedComment
    }
  }